// extracted by mini-css-extract-plugin
module.exports = {"pageDivider":"styles_pageDivider__31o3I"};